export const CDN_URL = 
"https://media-assets.swiggy.com/swiggy/image/upload/";


export const LOGO_URL = 
"https://thumbs.dreamstime.com/b/food-burger-logo-vector-emblem-design-template-128946515.jpg";




// export const MENU_API =
// "https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=23.190473&lng=79.926989&restaurantId=";
